import { descend, prop, sort } from 'ramda'

import { Params, ChangeLogType } from 'app/dataTypes/cafeteria/compensation/statements/changelog'
import SimpleDate from 'app/common/classes/simple-date'

import type { Request } from '../../../../index'


type ParamsApi = {
  withdraw_order_id: number
}

export const convertParams = ({
  statementID,
}: Params): [ParamsApi, null] => {
  return [{
    withdraw_order_id: parseInt(statementID, 10),
  }, null]
}

type ChnageLogApi = Array<{
  datetime: string
  comment: string
}>

export const convertResult = (data: ChnageLogApi): ChangeLogType => {
  const sorted = sort(descend(prop('datetime')), data)

  return sorted.map(({
    datetime,
    comment,
  }) => ({
    date: new SimpleDate(datetime),
    comment,
  }))
}

export const GET_COMPENSATION_WITHDRAW_ORDERS_CHANGELOG: Request<Params, ChangeLogType, void> = [
  'cabinet/compensation/withdraw_orders/changelog',
  'get',
  ['data', 'changes'],
]
